import * as React from "react";
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Input, Switch} from '@progress/kendo-react-inputs';
import {
  Label
} from "@progress/kendo-react-labels";
import { DateInput } from "@progress/kendo-react-dateinputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";


export const UserForm = () => {
  const handleSubmit = (dataItem) => alert('Data submitted');

  const countries = [{
    text: "USA",
    id: 1
  }, {
    text: "United Kingdom",
    id: 2
  }, {
    text: "Bulgaria",
    id: 3
  }];

  const [state, setState] = React.useState({
    value: {
      text: "USA",
      id: 1,
    },
  });

  const handleChange = (event) => {
    setState({
      value: event.target.value,
    });
  };

   return   <div>
       <Form
   initialValues={{
    username: 'Jaxons',
    email: 'jaxons@gmail.com',
    nickname: 'JX',
    phone: '(+1) 1234-567-89-01'
  }}
   render={(formRenderProps) => (

     <FormElement className="settings-form user-form">
       <fieldset className={'k-form-fieldset'}>
   <div className="settings-field">
        <div>
        <Label >Username</Label>
        <Field  component={Input} name={"username"} type={"text"} />
      </div>
        </div>

        <div className="settings-field">
      <div>
        <Label >Email Address</Label>
        <Field  component={Input} name={"email"} type={"email"}/>
      </div>
        </div>


        <div className="settings-field-row">
        <div className="settings-field">
        <div>
        <Label >Nickname</Label>
        <Field  component={Input} name={"nickname"} type={"text"}/>
      </div>
        </div>

        <div className="settings-field">
      <div>
        <Label >Phone Number</Label>
        <Field  component={Input} name={"phone"} type={"text"} />
      </div>
      </div>

        </div>

       </fieldset>
     </FormElement>
   )}
 />

 <Form
   initialValues={{
    website: 'jxnss.com',
    phone: '(+1) 1234-567-89-01'
  }}
   render={(formRenderProps) => (

     <FormElement className="settings-form user-form">
       <fieldset className={'k-form-fieldset'}>

   <div className="settings-field">
        <div>
        <Label >Birth Date</Label>
        <DateInput
         width="100%"
         name={"birthdate"}
        />
      </div>
        </div>

        <div className="settings-field">
      <div>
        <Label >Country</Label>
        <DropDownList
        data={countries}
        textField="text"
        dataItemKey="id"
        value={state.value}
        onChange={handleChange}
      />
      </div>
        </div>

        <div className="settings-field-row">
        <div className="settings-field">
        <div>
        <Label >Website</Label>
        <Field  component={Input} name={"website"} type={"text"}/>
      </div>
        </div>

        <div className="settings-field">
      <div>
        <Label >Phone Number</Label>
        <Field  component={Input} name={"phone"} type={"text"} />
      </div>
      </div>
        </div>
       </fieldset>
     </FormElement>
   )}
 />

  <Form
   initialValues={{
    password: 'password'
  }}
  onSubmit={handleSubmit}

   render={(formRenderProps) => (

     <FormElement className="settings-form user-form password-form">
       <fieldset className={'k-form-fieldset'}>

   <div className="settings-field">
        <Label >Current Password</Label>
        <Field  component={Input} name={"password"} type="password" />
       </div>

       <div className="settings-field">
        <Label >New Password</Label>
        <Field  component={Input}  type="password" />
       </div>

     <div className="settings-option">
       <div className="switch-parent">
      <p>Enable 2-step authentication</p>
      <Switch  />
    </div>
    </div>

    <div className="settings-option">
       <div className="switch-parent">
      <p>Enable 2-step authentication</p>
      <Switch  />
    </div>
    </div>


       </fieldset>

       <div className="k-form-buttons form-actions">
        <div>
        <span>Public Profile</span>

       <Switch className="settings-switch"/>
        </div>

        <div>
        <button type={'submit'} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base secondary-action" disabled={!formRenderProps.allowSubmit}>
          Cancel
        </button>
       <button type={'submit'} className="k-selected k-button k-button-md k-button-rectangle k-rounded-md k-button-solid k-button-solid-primary k-form-submit" disabled={!formRenderProps.allowSubmit}>
         Save Changes
        </button>
        </div>
        </div>
     </FormElement>
   )}
 />

   </div>
   }